export default __webpack_public_path__ + "static/media/personal.05d0404a.png";